module.exports = {
  AMPLITUDE_API_KEYS: {
    QA: "9f0f370fab408d6e388b0aedce7d7f5d",
    STAGING: "fe68f6456a5b8261fb971f9ef7b0825f",
    PRODUCTION: "b632c2d052db2bf1e2da225654d64cce"
  }
};
